// extracted by mini-css-extract-plugin
export default {"container":"Sk-z","freeShip":"Tk-z","privacy":"Uk-z"};